export enum ThumbnailSizeEnum {
    MINI = 'mini',
    FULL = 'full',
  }